import { UseFormRegister, FieldErrorsImpl, FieldArrayWithId } from 'react-hook-form';
import cx from 'classnames';

import { Circle } from 'phosphor-react';
import { JOB_CATEGORIES } from 'constants/report-codes';
import { FormValues } from 'types/job-category-mapping';
import Arrow from 'assets/images/arrow.svg';

function JobCategoryMapping({
  register,
  errors,
  fields,
  unconfirmedJobCategories,
  confirmJobCategory
}: {
  register: UseFormRegister<FormValues>;
  errors: Partial<FieldErrorsImpl<FormValues>>;
  fields: Array<FieldArrayWithId<FormValues, 'mappings', 'id'>>;
  unconfirmedJobCategories: string[];
  confirmJobCategory: Function;
}): JSX.Element {
  return (
    <>
      {fields.map((item, id) => {
        const { onChange, onBlur, name, ref } = register(`mappings.${id}.jobCategory.id` as const, {
          required: true
        });
        const handleJobCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
          void onChange(event);
          if (event.target.value !== '') {
            confirmJobCategory(item.jobTitle);
          }
        };
        const confidence = !unconfirmedJobCategories.includes(item.jobTitle);
        return (
          <tr key={id}>
            <td>
              {!confidence && <Circle weight="fill" className="inline text-red-500" size={12} />}
            </td>
            <td
              className={cx('px-3 py-2 whitespace-nowrap text-sm', {
                'font-bold': !confidence
              })}>
              {item.jobTitle}
            </td>
            <td>
              <div
                className="h-6 bg-no-repeat bg-right mx-4"
                style={{ backgroundImage: `url(${Arrow as string})` }}></div>
            </td>
            <td className="pr-0 py-2 w-full">
              <select
                className={cx('select w-96', { error: !confidence })}
                aria-label="Default select example"
                onChange={handleJobCategoryChange}
                onBlur={(event) => {
                  void onBlur(event);
                }}
                name={name}
                ref={ref}>
                <option value="">– Select Job Category –</option>
                {JOB_CATEGORIES.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                    {item.jobCategory.confidence === false &&
                      item.jobCategory.id === category.id &&
                      ' (low confidence)'}
                  </option>
                ))}
              </select>
              {errors?.mappings?.[id] != null && (
                <p className="error-message">Please select job category.</p>
              )}
            </td>
          </tr>
        );
      })}
    </>
  );
}

export default JobCategoryMapping;
